export default __webpack_public_path__ + "static/media/minus.aa2c9eed.svg";